document.addEventListener("DOMContentLoaded", function () {
  const carousels = document.querySelectorAll(".reviews-carousel-section");

  carousels.forEach((section) => {
    const container = section.querySelector(".reviews-carousel__container");
    const prevBtn = section.querySelector(".nav-prev");
    const nextBtn = section.querySelector(".nav-next");

    if (!container || !prevBtn || !nextBtn) return;

    // Mouse dragging logic
    let isDown = false;
    let startX;
    let scrollLeft;

    container.addEventListener('mousedown', (e) => {
      isDown = true;
      container.classList.add('dragging');
      startX = (e).pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener('mouseleave', () => {
      isDown = false;
      container.classList.remove('dragging');
    });

    container.addEventListener('mouseup', () => {
      isDown = false;
      container.classList.remove('dragging');
    });

    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = (e).pageX - container.offsetLeft;
      const walk = (x - startX) * 2; // scroll speed multiplier
      container.scrollLeft = scrollLeft - walk;
    });

    prevBtn.addEventListener("click", () => {
      container.scrollBy({ left: -400, behavior: "smooth" }); 
    });

    nextBtn.addEventListener("click", () => {
      container.scrollBy({ left: 400, behavior: "smooth" });
    });

    // Video Control Logic
    const videoCards = section.querySelectorAll('.review-card');
    const allVideos = section.querySelectorAll('[data-review-video]');

    videoCards.forEach(card => {
      const video = card.querySelector('[data-review-video]');
      const playBtn = card.querySelector('.review-card__play-button');

      if (!video || !playBtn) return;

      playBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        
        if (video.paused) {
          // Pause all other videos
          allVideos.forEach(v => {
            if (v !== video) {
              v.pause();
              v.closest('.review-card').classList.remove('review-card--playing');
              const otherBtn = v.closest('.review-card').querySelector('.review-card__play-button');
              if (otherBtn) otherBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
            }
          });

          video.play();
          card.classList.add('review-card--playing');
          playBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>';
        } else {
          video.pause();
          card.classList.remove('review-card--playing');
          playBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
        }
      });

      // Optional: Pause when clicking the card itself if it's already playing
      card.addEventListener('click', () => {
        if (!video.paused) {
          video.pause();
          card.classList.remove('review-card--playing');
          playBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>';
        }
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById('ReviewModal');
  if (!modal) return;

  const overlay = modal.querySelector('.review-modal__overlay');
  const closeBtn = modal.querySelector('.review-modal__close');
  const contentMedia = modal.querySelector('.review-modal__media');
  const contentUser = modal.querySelector('.review-user--modal');
  const contentRating = modal.querySelector('.review-modal__rating');
  const contentText = modal.querySelector('.review-modal__text');

  function openModal(card) {
    const type = card.dataset.mediaType;
    const reviewText = card.dataset.reviewText;
    const userName = card.dataset.userName;
    const userImage = card.dataset.userImage;
    const userInitial = card.dataset.userInitial;
    const userInitialBg = card.dataset.userInitialBg;
    const rating = card.dataset.rating;

    // Populate User
    let avatarHtml = '';
    if (userImage) {
      avatarHtml = `<div class="review-user__avatar"><img src="${userImage}" loading="lazy"></div>`;
    } else {
      avatarHtml = `<div class="review-user__avatar" style="background-color: ${userInitialBg}">${userInitial}</div>`;
    }
    contentUser.innerHTML = `${avatarHtml}<div class="review-user__name">${userName}</div>`;

    // Populate Text
    contentText.textContent = reviewText;

    // Populate Rating
    contentRating.innerHTML = `<span>★</span> ${rating}`;

    // Populate Media
    contentMedia.innerHTML = '';
    if (type === 'video') {
      const poster = card.dataset.videoPoster;
      const sourcesStr = card.dataset.videoSources;
      
      const video = document.createElement('video');
      video.controls = true;
      video.autoplay = true;
      video.poster = poster;
      video.style.width = '100%';
      video.style.height = '100%';
      
      if (sourcesStr) {
        const sources = sourcesStr.split(',');
        sources.forEach(srcStr => {
           const parts = srcStr.split('|');
           if (parts.length === 2) {
             const source = document.createElement('source');
             source.src = parts[0];
             source.type = parts[1];
             video.appendChild(source);
           }
        });
      }
      contentMedia.appendChild(video);
    } else {
      const imgSrc = card.dataset.imageSrc;
      const img = document.createElement('img');
      img.src = imgSrc;
      contentMedia.appendChild(img);
    }

    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    contentMedia.innerHTML = ''; // Stop video
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  // Esc key support
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });

  // Attach to cards
  const cards = document.querySelectorAll('.review-card');
  cards.forEach(card => {
    card.addEventListener('click', (e) => {
      // Don't open if clicking play button (handled by other script)
      if (e.target.closest('.review-card__play-button')) return;
      
      openModal(card);
    });
  });
});
